import { useEffect } from 'react';
import { connect } from "react-redux";
import { setOnAir } from "../actions/index";

// Player can reject some tracks but we need to mark it on the UI
function ConnectedRejectWrapper({ data, setOnAir }) {
  useEffect( () => {
    if (data) {
      setOnAir(data.pid, data.trackID)
    }
  }, [data, setOnAir])
  return null;
}

const RejectWrapper = connect(
  null,
  dispatch => ({
    setOnAir: (pid, trackID) => dispatch(setOnAir(pid, trackID)),
  })
)(ConnectedRejectWrapper);

export default RejectWrapper;
